// TODO: Populate urls w/ SFBLIs API address
export const apiConfig = {
  baseUrl: 'https://salesleads.sfbli.com/api',
  endpoint: '/CalculatorData'
}
